import { getStoredLanguage } from './languageStorage'
import {
  HIDDEN_UI_LANGUAGES,
  SUPPORTED_LANGUAGES,
  type SupportedLanguage,
} from './supportedLanguages'

/** localStorage key holding the persisted "German UI" debug flag. */
export const GERMAN_UI_FLAG_KEY = 'debug:germanUi'

/** Reads the persisted German-UI debug flag. Safe to call at module init. */
export function readGermanUiEnabled(): boolean {
  try {
    return window.localStorage.getItem(GERMAN_UI_FLAG_KEY) === 'true'
  } catch {
    return false
  }
}

/** UI languages the picker may show, given whether German is debug-enabled. */
export function getSelectableUiLanguages(germanEnabled: boolean): SupportedLanguage[] {
  const hidden = HIDDEN_UI_LANGUAGES as readonly string[]
  return SUPPORTED_LANGUAGES.filter(
    (lng) => !hidden.includes(lng) || (germanEnabled && lng === 'de')
  )
}

/**
 * The active UI language to apply, derived from the stored preference.
 * A hidden language (German) falls back to English while its flag is off —
 * WITHOUT mutating the stored preference, so it auto-restores when re-enabled.
 */
export function getEffectiveUiLanguage(): SupportedLanguage {
  const stored = getStoredLanguage()
  if (stored === null) return 'en'
  const hidden = HIDDEN_UI_LANGUAGES as readonly string[]
  if (hidden.includes(stored) && !readGermanUiEnabled()) return 'en'
  return stored
}
